<template lang="pug">
.content-wrap(:class="'column is-offset-1 is-10'")
    div.information.speech-bubble.bubble-left.column.is-5.z-depth-1(
        v-if="content || images"
        :class="[hasReactions ? '' : 'no-reaction', isContentColorBlue ? 'is-blue' : '']"
        :style="{ 'background-color': contentColor, 'border-right-color': contentColor }"
    )
        .content-text(v-if="content.text" v-html="content.text" :class="{'collapsed': collapsed}" :style="{'color': textContrast}")
        .readmore(v-if="collapsed && hasReadmore")
            .click-me(@click="toggleCollapse") Mehr Lesen
        EvalImage(
            v-if="images"
            v-for="image in images"
            :key="image.id"
            :image="getImage(image)"
        )
    Reactions.reactions.speech-bubble.bubble-right.column.is-offset-7.is-5.z-depth-1(
        v-if="hasReactions && reactions[0].input_type != 'nextInformation'"
        :reactions="reactions"
        :information="information"
        :answered="answered"
        :section="section"
    )
</template>
<script>
import _ from 'lodash'

import Heading from './Heading'
import PostImage from './PostImage'
import Reactions from './Reactions'
import EvalImage from './EvalImage'

export default {
    name: 'Information',
    components: {
        Heading,
        PostImage,
        Reactions,
        EvalImage
    },
    data() {
        return {
            collapsed: false,
            hasReadmore: false
        }
    },
    props: {
        information: {
           type: Object,
           required: true
        },
        answered: {
            type: Boolean
        },
        section: {
            type: Object,
            required: true
        }
    },
    computed: {
        contents() {
            return this.information.contents || []
        },
        heading() {
            return this.contents.find(content => content.key === 'heading')
        },
        content() {
            let Content = this.contents.find(content => content.key === 'information-content')
            if(!Content) return false
            if(!Content.text) return false
            if(Content.text.length >= 350){
                this.collapsed = true,
                this.hasReadmore = true
            }
            return Content
        },
        contentColor() {
            let color = '#fff'
            if(this.content.color) color = this.content.color
            return color
        },
        isContentColorBlue() {
            if (this.contentColor == '#3389CE' || this.contentColor == '#3389ce') {
                return true
            }else {
                return false
            }
        },
        textContrast() {
            let rgb = this.hexToRBG(this.contentColor)
            let brightness = Math.round(((parseInt(rgb.r) * 299) + (parseInt(rgb.g) * 587) + (parseInt(rgb.b) * 114)) / 1000)
            let textColor = (brightness > 125) ? '#363636' : '#FFFFFF'
            return textColor
        },
        images() {
            let Content = this.contents.find(content => content.key === 'information-image')
            if(!Content) return false
            if(Content.images.length <= 0) return false
            return Content.images
        },
        reactions() {
            return _.get(this.information, 'reactions', [])
        },
        hasReactions() {
            if (this.reactions.length >= 1) return true
            return false
        }
    },
    methods: {
        toggleCollapse() {
            this.collapsed = !this.collapsed
            this.hasReadmore = !this.hasReadmore
        },
        getImage(image = null) {
            if (! image) return false

            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            let fit = _.get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1'
            const parameters = {
                ... _.get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups'),
            }
            let { w, h } = parameters

            if (w && h) {
                const aspectRatio = 17 / 7

                h = 320
                w = h * aspectRatio
                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${w}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${h}`)
            } else if (! w && ! h) {
                h = 320
                fit += `&h=${h}`
            }

            return {
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
            }
        },
        hexToRBG(hex) {
            let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            hex = hex.replace(shorthandRegex, function(m, r, g, b) {
                return r + r + g + g + b + b;
            });

            let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
            } : null;
        }
    }
}
</script>
<style lang="sass">
    .speech-bubble
        position: relative
        background-color: #fff
        border-radius: 10px
    .speech-bubble:after
        position: absolute
        content: ""
        width: 0
        height: 0
        border-style: solid
    .bubble-left
        position: relative
    .bubble-left:after
        border-width: 10px 10px 10px 0
        top: 15px
        left: -10px
        border-color: transparent inherit transparent transparent
        border-bottom-color: transparent
        border-top-color: transparent
        border-left-color: transparent
        border-right-color: inherit

    .bubble-right
        position: relative
        margin-top: 24px
    .bubble-right:after
        border-width: 10px 0 10px 10px
        top: 15px
        right: -10px
        border-color: transparent transparent transparent #fff
    .readmore
        position: absolute
        bottom: 0
        left: 0
        width: 100%
        padding-top: 40px
        padding-left: 10px
        background-image: linear-gradient(to bottom, transparent, white)
        border-bottom-left-radius: 10px
        border-bottom-right-radius: 10px
        .click-me
            color: #084375
            text-align: center
            &:hover
                color: #0078de
                cursor: pointer
    .collapsed
        max-height: 350px
        overflow: hidden
        margin-bottom: 15px
    .information
        a
            color: #084375
            text-decoration: underline
            &:hover
                color: #1ea3ba
        &.is-blue
            background-color: #3389CE
            color: #FFF
            &:after
                border-color: transparent #3389CE transparent transparent
            a
                color: #FFF
                &:hover
                    color: #073c69

    // .no-reaction
    //     background-color: #d5d7ec
    // .no-reaction:after
    //     border-color: transparent #d5d7ec transparent transparent
</style>
